export default function H3({ text }: header) {
  return (
    <h3 className="text-lg font-medium leading-6 text-gray-900">{text}</h3>
  );
}

interface header {
  text: string;
}
